export function getOnboardingRequestProgress(row) {
  if (['pending', 'rejected'].includes(row?.request_status)) {
    return null;
  }

  const hasRequired = Number(row?.needed_items ?? 0) > 0;
  const denom = hasRequired
    ? Number(row?.needed_items ?? 0)
    : Number(row?.total_items ?? 0);
  const numer = hasRequired
    ? Number(row?.completed_items ?? 0)
    : Number(row?.total_completed_items ?? 0);

  return denom === 0 ? 100 : (numer / denom) * 100;
}

export function getOnboardingRequestStatusLabel(t, row) {
  if (row?.request_status === 'rejected') {
    return t('corporate-onboarding.request-rejected', {
      defaultValue: 'Onboarding Request Not Accepted',
    });
  }

  if (row?.request_status === 'pending') {
    return t('corporate-onboarding.request-pending', {
      defaultValue: 'Request pending',
    });
  }

  if (row?.is_marked_compliant) {
    return t('corporate-onboarding.request-compliant', {
      defaultValue: 'Marked compliant',
    });
  }

  if (getOnboardingRequestProgress(row) >= 100) {
    return t('corporate-onboarding.request-complete', {
      defaultValue: 'Complete',
    });
  }

  return t('corporate-onboarding.request-started', {
    defaultValue: 'Ready to complete',
  });
}
